var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4172 8.41908C11.4773 7.66336 12.1685 6.42373 12.1685 5.02265C12.1685 2.72057 10.3023 0.85437 8.00025 0.85437C5.69817 0.85437 3.83197 2.72057 3.83197 5.02265C3.83197 6.42373 4.52324 7.66336 5.58333 8.41908C2.82631 9.40985 0.85463 12.0475 0.85463 15.1456H2.04557C2.04557 11.8569 4.71157 9.19093 8.00025 9.19093C11.2889 9.19093 13.9549 11.8569 13.9549 15.1456H15.1459C15.1459 12.0475 13.1742 9.40985 10.4172 8.41908ZM10.9776 5.02265C10.9776 6.66699 9.64459 7.99999 8.00025 7.99999C6.35591 7.99999 5.02291 6.66699 5.02291 5.02265C5.02291 3.37831 6.35591 2.04531 8.00025 2.04531C9.64459 2.04531 10.9776 3.37831 10.9776 5.02265Z",
    fill: "#00A000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileActive);
export default __webpack_public_path__ + "static/media/profile-active.f2e0496c292868fcd3ec0162137fbe30.svg";
export { ForwardRef as ReactComponent };